import { Component, OnInit , inject, DestroyRef} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { SystemService } from 'src/app/services/api/system.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ClipboardService } from 'ngx-clipboard';
import { UrlService } from 'src/app/services/util/url.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { Instance } from 'src/app/models/instance/instance';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { PrivateEndpointsService } from 'src/app/services/api/private-endpoints-service';
import { ApproveDialogComponent } from 'src/app/components/approve-dialog/approve-dialog.component';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_NONPII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_NONPII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_PII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_PII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.PRIVATE_EP_APPROVE_PII,
    action: Permissions.PRIVATE_EP_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.PRIVATE_EP_APPROVE_LIVE,
    action: Permissions.PRIVATE_EP_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.PRIVATE_EP_REJECT_PII,
    action: Permissions.PRIVATE_EP_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.PRIVATE_EP_REJECT_LIVE,
    action: Permissions.PRIVATE_EP_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.PRIVATE_EP_DELETE_PII,
    action: Permissions.PRIVATE_EP_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.PRIVATE_EP_DELETE_LIVE,
    action: Permissions.PRIVATE_EP_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.PRIVATE_EP_CREATE_PII,
    action: Permissions.PRIVATE_EP_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.PRIVATE_EP_CREATE_LIVE,
    action: Permissions.PRIVATE_EP_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.PRIVATE_EP_READ_PII,
    action: Permissions.PRIVATE_EP_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.PRIVATE_EP_READ_LIVE,
    action: Permissions.PRIVATE_EP_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-edge-network-details',
    templateUrl: './edge-network-details.component.html',
    styleUrls: ['./edge-network-details.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class EdgeNetworkDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  RouterSegments = RouterSegments;
  PermissionKeys = PermissionKeys;
  breadcrumbItems: BreadcrumbItem[] = [];
  tenantId: string;
  dataZone: string;
  tenantDetails: any;
  azureTsiSolutionId: string;
  currentVersion: string;
  solutionVersions: any;
  solution: any;
  instanceDetails: any;
  isLoading = true;
  copy = false;
  idCopy = false;
  count: any;
  searchTerm: string;
  pageName = 'privateEndpoint';
  dropdownsList: any;
  endpointStatus: any;
  status: any;
  filteredColumns: any;
  clearData: boolean;
  endpointsData = [];
  selectedStatus = [];
  searchedResult = [];
  displayColumns = [
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'connectionName',
      name: translate('EDGE_NETWORK_DETAILS.CONNECTION_NAME'),
      type: 'text',
      sortable: true,
      keyLink: 'privateEndpoint',
      visible: true,
      disable: true
    },
    {
      key: 'resource',
      name: translate('EDGE_NETWORK_DETAILS.RESOURCE'),
      type: 'text',
      sortable: true,
      keyLink: 'resourceId',
      visible: true,
      disable: false
    },
    {
      key: 'service',
      name: translate('EDGE_NETWORK_DETAILS.SERVICE'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'modifiedBy',
      name: translate('EDGE_NETWORK_DETAILS.MODIFIED_BY'),
      type: 'userIcon',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'modifiedAt',
      name: translate('EDGE_NETWORK_DETAILS.MODIFIED_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'description',
      name: translate('EDGE_NETWORK_DETAILS.DESCRIPTION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'ticketNumber',
      name: translate('EDGE_NETWORK_DETAILS.TICKET_ID'),
      type: 'text',
      sortable: true,
      keyLink: 'ticketNumber',
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('EDGE_NETWORK_DETAILS.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'edgeNetworkSettings',
      name: '',
      type: 'settings'
    }
  ];
  endpoints: any;
  nonpiiStartStop: boolean;
  piiStartStop: boolean;
  instanceClass = DeploymentClass;
  permissionsMap: { [key: string]: boolean };
  DeployStatus = DeployStatus;
  instanceList: any;
  inprogressStatus = [DeployStatus.DEPLOYING, DeployStatus.INITIALIZING, DeployStatus.UPDATING, DeployStatus.CONFIGURING, DeployStatus.TESTING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.STARTING, DeployStatus.STOPPING];
  errorStatus = [DeployStatus.FAILED, DeployStatus.INITIALIZE_FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.START_FAILED, DeployStatus.STOP_FAILED];
  terminateStatus = [DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.TERMINATION_FAILED, DeployStatus.STOPPED];
  completedStatus = [DeployStatus.DEPLOYED, DeployStatus.INITIALIZED, DeployStatus.UPDATED, DeployStatus.CONFIGURED, DeployStatus.TESTED];
  endpointsLoading = true;
  showLoader = false;
  isAWS: boolean;

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.INPROGRESS];
    enableApprove: boolean;
    enableDelete: boolean;
    endpointData: any;
    enableReject = false;

  constructor(private activatedRoute: ActivatedRoute, public authService: AuthService, private instanceService: InstancesService,
    private sidenavService: SidenavService, private tenantService: TenantService, private systemService: SystemService,
    private solutionsService: SolutionsService, private toastrService: CustomToastrService, private router: Router,
    private clipboardApi: ClipboardService, public urlService: UrlService, private permissionsService: PermissionsService,
     private dialog: MatDialog, private errorPageService: ErrorPageService, private privateEndpointsService: PrivateEndpointsService) {
    
  }

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'LEFT_SIDE_NAV.EDGE_NETWORK';
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.dataZone = this.activatedRoute.snapshot.params.envt;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    const breadcrumb = this.dataZone === 'nonprod' ? 'Non Prod' : this.dataZone === 'nonpii' ? 'Non PII' :
      this.dataZone === 'pii' ? 'PII' : this.dataZone === 'prod' ? 'Prod' : '';
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
      {label: translate('LEFT_SIDE_NAV.EDGE_NETWORK'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.EDGE_NETWORK]},
      {label: breadcrumb});

      this.endpointStatus = [
      {value: 'approved', label: "Approved",selected: false},
      {value: 'approving', label: "Approving",selected: false},
      {value: 'approval_pending', label: "Approval Pending",selected: false},
      {value: 'approval_failed', label: "Approval Failed",selected: false},
      {value: 'rejected', label: "Rejected", selected: false},
      {value: 'rejecting', label: "Rejecting",selected: false},
      {value: 'rejection_failed', label: "Rejection Failed",selected: false},
      {value: 'deleted', label: "Deleted", selected: false},
      {value: 'deleting', label: "Deleting",selected: false},      
      {value: 'deletion_failed', label: "Deletion Failed", selected: false}
    ];

    this.dropdownsList = [
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.endpointStatus
      }
    ];

    if (localStorage.getItem('filteredEndpointsStatus')) {
      this.status = JSON.parse(localStorage.getItem('filteredEndpointsStatus'));
      if (this.status) {
        this.selectedStatus = this.status;
        this.status = this.selectedStatus;
        this.dropdownsList[0]?.options.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    this.loadData(this.tenantId);
    this.loadPrivateEndpoints();
    this.loadInstances();
  }

  loadData(tenantId): void {
    this.isLoading = true;
    this.tenantService.getTenantDetails(tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.tenantDetails = data;
      if (this.tenantDetails?.sharedInfra[this.dataZone]?.publicLoadBalancerUrl && this.tenantDetails?.sharedInfra[this.dataZone]?.publicLoadBalancerUrl?.startsWith('https://')) {
        this.tenantDetails.sharedInfra.prod.publicLoadBalancerUrl = this.tenantDetails?.sharedInfra[this.dataZone]?.publicLoadBalancerUrl;
      } else if (this.tenantDetails?.sharedInfra[this.dataZone]?.publicLoadBalancerUrl){
        this.tenantDetails.sharedInfra[this.dataZone].publicLoadBalancerUrl = 'https://'+ this.tenantDetails?.sharedInfra[this.dataZone]?.publicLoadBalancerUrl;
      }
      if ((this.tenantDetails.cloudProvider === translate('TENANT_DETAILS.AWS') || this.tenantDetails.targetCloud === translate('TENANT_DETAILS.AWS'))) {
        const tenant = this.authService.principal.provider;
        this.router.navigate(['/', tenant, 'tenant', 'error', '404'], {skipLocationChange: true});
      }
      if(this.tenantDetails?.parameters?.instanceStopStart?.length > 0) {
        this.tenantDetails?.parameters?.instanceStopStart.forEach(data => {
          if (data === 'nonpii') {
            this.nonpiiStartStop = true;
          }
          if (data === 'pii') {
            this.piiStartStop = true;
          }
        })
      }
      this.systemService.getSystem().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        if(response.azureTsiSolutionId) {
          this.azureTsiSolutionId = response.azureTsiSolutionId;
          this.getSolutionDetails();
          this.solutionsService.getSolutionVersions(response.azureTsiSolutionId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
            if (data) {
              this.solutionVersions = data;
              const availableService = this.tenantDetails?.sharedInfra?.[this.dataZone];
              if (!this.tenantDetails?.sharedInfra?.[this.dataZone]) {
                this.errorPageService.show404Page()
              }
              if (availableService && availableService?.instanceId) {
                this.instanceService.getInstanceById(this.tenantDetails?.sharedInfra?.[this.dataZone]?.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(instanceData => {
                  this.isLoading = false;
                  this.instanceDetails = instanceData;
                  const currentSolutionVersionId = instanceData.solutionVersionId;
                  data.forEach((value) => {
                    if (value.id === currentSolutionVersionId) {
                      this.currentVersion = value.version;
                    }
                  });
                });
              }
            }
          });
        }
      });
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  getSolutionDetails(): void {
    this.solutionsService.getSolutionById(this.azureTsiSolutionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      this.solution = result;
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  loadInstances(): void {
    const obj = {
      tenantId: this.tenantId
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data?.total > 10) {
          const instanceObj = {
            size: data.total,
            tenantId: this.tenantId
          };
          this.instanceService.getInstances(instanceObj)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(instances => {
              this.instanceList = instances.data;
          });
        } else {
          this.instanceList = data.data;
        }
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  loadPrivateEndpoints(): void {
    this.privateEndpointsService.getPrivateEndpoints(this.tenantId, this.dataZone)
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      this.endpoints = data;
      this.searchTerm = '';
      this.endpointsData = data;
      this.endpointsLoading = false;
      this.showLoader = false;
      if (this.status?.length) {
        this.endpoints = this.endpoints?.filter(item => this.selectedStatus?.includes(item?.status));
        this.endpointsData = this.endpoints;
      }
      this.endpoints.forEach(item => {
        item.selected = false;
        if (!item.status || item.status === 'pending') {
          item.status = 'approval_pending'
        }
      });
    });

    // if (localStorage.getItem('filteredEndpointsStatus')) {
    //   this.status = JSON.parse(localStorage.getItem('filteredEndpointsStatus'));
    //   if (this.status) {
    //     this.selectedStatus = this.status;
    //     this.status = this.selectedStatus;
    //     this.dropdownsList[0]?.options.forEach(element => {
    //       if(this.selectedStatus.find(item=> item === element.value)) {
    //         element.selected = true;
    //       }
    //     });
    //     this.endpoints = this.endpoints?.filter(item => this.selectedStatus?.includes(item?.status));
    //     this.endpointsData = this.endpoints;
    //     console.log('this.endpoints', this.endpoints);
    //   }
    // }
    
  }

  onCopyUrl(url, field?): void {
    if (field === 'id') {
      this.idCopy = true;
    } else {
      this.copy = true;
    }
    this.clipboardApi.copyFromContent(url);
    setTimeout(() => {
      this.idCopy = false;
      this.copy = false;
    }, 5000);
  }

  instanceIdClick(): void {
    if (this.instanceDetails?.id) {
      this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
      this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.BLUEPRINTS, this.instanceDetails.blueprintId, RouterSegments.ENVIRONMENT, this.instanceDetails.id]);
    }
  }

  displayInstanceStatus(status?: any): string {
    if (status === DeployStatus.STOPPED || status === DeployStatus.START_FAILED || status === DeployStatus.STOPPING) {
      return 'Start';
    } else {
      return 'Stop';
    }
  }

  actionClick(event): void {
    event.stopPropagation();
  }

  isInprogressStatus(status): any {
    return this.INSTANCE_DEPLOYING_STATES.includes(status);
  }

  validateInstance(instance?: Instance, key?: string): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.changeInstanceStatus(instance, key);
    } else if (this.instanceList?.length !== 0) {
      if (key === 'nonpii' || 'nonprod') {
        const instancesToCheck = this.instanceList?.filter(item => item.dataZone === DataZone.DEVELOPMENT);
        if (instancesToCheck.some(item => item.status !== DeployStatus.STOPPED)) {
          this.openErrorDialog(key === 'nonpii' ? 'TENANT_DETAILS.INSTANCES_EDGENW_NONPII' : 'TENANT_DETAILS.INSTANCES_EDGENW_NONPROD');
        } else {
          this.changeInstanceStatus(instance, key);
        }
      } else if (key === 'pii') {
        const instancesToCheck = this.instanceList?.filter(item => item.dataZone === DataZone.SECURE);
        if (instancesToCheck.some(item => item.status !== DeployStatus.STOPPED)) {
          this.openErrorDialog('TENANT_DETAILS.INSTANCES_EDGENW_PII');
        } else {
          this.changeInstanceStatus(instance, key);
        }
      }
    } else {
      this.changeInstanceStatus(instance, key);
    }
  }

  openErrorDialog(data): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '240px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('BLUEPRINT_SUMMARY.VALIDATION_ERROR'),
        description: translate(data)
      }
    });
  }

  getApproveData(event): void {
    this.endpointData = event;
    if(event.status === 'approval_pending' || event.status === 'approval_failed') {
      this.enableApprove = true;
    } else {
      this.enableApprove = false;
    }
    if(event.status === 'approved' || event.status === 'delete_failed' || event.status === 'deletion_failed'){
      this.enableDelete = true;
    }else{
      this.enableDelete = false;
    }
    if (event.status === 'approval_pending' || event.status === 'rejection_failed' || event.status === 'approved') {
      this.enableReject = true;
    } else {
      this.enableReject = false;
    }
  }

  onApproveClick(data): void {
    const privateEndpointId = data.id;
    this.dialog.open(ApproveDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('EDGE_NETWORK_DETAILS.APPROVE_CONFIRMATION_HEADING'),
        message: translate('EDGE_NETWORK_DETAILS.APPROVE_CONFIRMATION_MESSAGE'),
        confirmButtonText: translate('DIALOG.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if (response) {
          response.tenantId = this.tenantId,
          response.id = privateEndpointId
          this.privateEndpointsService.approvePrivateEndpoints(response)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
            if(data) {
            this.loadPrivateEndpoints();
            }
          }, (error) => {
            const description = error?.message 
            || error?.error?.message 
            || error?.errmsg 
            || translate('SERVICE.INTERNAL_SERVER_ERROR');
            setTimeout(() => {
              this.openErrorDialog(error);
            }, 500);
          })
        }
      })
  }

  onRejectClick(data): void {
    const privateEndpointId = data.id;
    this.dialog.open(ApproveDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('EDGE_NETWORK_DETAILS.REJECT_EP_CONNECTION'),
        message: translate('EDGE_NETWORK_DETAILS.REJECT_EP_MESSAGE'),
        confirmButtonText: translate('DIALOG.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if (response) {
          response.tenantId = this.tenantId,
          response.id = privateEndpointId
          this.privateEndpointsService.rejectPrivateEndpoints(response)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
            if(data) {
            this.loadPrivateEndpoints();
            }
          }, (error) => {
            const description = error?.message 
            || error?.error?.message 
            || error?.errmsg 
            || translate('SERVICE.INTERNAL_SERVER_ERROR');
            setTimeout(() => {
              this.openErrorDialog(error);
            }, 500);
          })
        }
      })
  }


  changeInstanceStatus(instance?: Instance, key?: string): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_START_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_START_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.instanceStart(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.tenantDetails.sharedInfra[key].instanceDetails = data;
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE');
              const message = translate('INSTANCE_DETAILS.INSTANCE_START_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.INSTANCE_START_FAILED'),
                    description: errorMessage,
                  }
               })
              });
          }
      });
    }

    else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_STOP_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_STOP_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.instanceStop(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.tenantDetails.sharedInfra[key].instanceDetails = data;
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE');
              const message = translate('INSTANCE_DETAILS.INSTANCE_STOP_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.INSTANCE_STOP_FAILED'),
                description: errorMessage
              }
            });
                });
          }
      });
    }
  }


  syncPrivateEndpoint(): void {
    this.privateEndpointsService.syncPrivateEndpoints(this.tenantId, this.dataZone)
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (result) => {
          if (result) {
            this.count = this.count !== 1 ? 1 : 0;
            setTimeout(() => {
              this.showLoader = true;
              this.loadPrivateEndpoints();
            }, 5000);
            // Handle successful sync
            // Consider showing a success notification to the user
          } else {
            // Handle empty or invalid result
          }
        },
        /*error: (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {
              title: translate(`${error.httpStatusCode}` + `  ${error.error}`),
              description: errorMessage
            }
          });
        },*/
        error : (error) => {
                    const description = error?.message 
                    || error?.error?.message 
                    || error?.errmsg 
                    || translate('SERVICE.INTERNAL_SERVER_ERROR');
                    setTimeout(() => {
                      this.openErrorDialog(error);
                    }, 500);
                  },
        complete: () => {
          // Optional: Handle completion if needed
        }
      });
  }


  deletePrivateEndpoint(data): void {
    const privateEndpointId = data.id;
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('EDGE_NETWORK_DETAILS.DELETE_EP_CONNECTION'),
        message: translate('EDGE_NETWORK_DETAILS.DELETE_EP_CONFIRMATION'),
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.privateEndpointsService.deletePrivateEndpoints(this.tenantId, data.id)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
            if(data) {
            this.loadPrivateEndpoints();
            }
          }, (error) => {
            const description = error?.message 
            || error?.error?.message 
            || error?.errmsg 
            || translate('SERVICE.INTERNAL_SERVER_ERROR');
            setTimeout(() => {
              this.openErrorDialog(error);
            }, 500);
          })
        }
      })
  }

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  searchedItems(result): void {
    this.searchedResult = result;
  }

  filterColumns(): void {
    if(this.status) {
      this.dropdownsList[0].options.filter((item) => {
        if (this.status?.find(status => status === item.value)) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('EDGE_NETWORK_DETAILS.PRIVATE_ENDPOINT_FILTER_NAME'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      PEStatus: this.dropdownsList[0].options,
      privateEndpointsColumns: [
        'status'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        this.clearData = true;
        if(filteredColumns[0] !== '') {
          this.status = filteredColumns[0];
        }
        this.filterEndpointsItems(filteredColumns);
      }
    });
  }

  filterEndpointsItems(filteredColumns): void {
    if (filteredColumns) {
      this.endpoints = this.endpointsData;
      this.selectedStatus = [];

      if (filteredColumns[0]?.length > 0) {
        this.selectedStatus = filteredColumns[0];
        localStorage.setItem('filteredEndpointsStatus', JSON.stringify(this.selectedStatus));
        this.endpoints = this.endpoints?.filter(item => this.selectedStatus?.includes(item?.status));
      } else {
        localStorage.removeItem('filteredEndpointsStatus');
      }
    }
  }

  getStatusLabel(status): void {
    return this.endpointStatus.find(item=> item.value === status).label;
  }

  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredEndpointsStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredEndpointsStatus', JSON.stringify(this.selectedStatus));
      this.filterEndpointsItems(this.filteredColumns);
    }
    if (this.selectedStatus.length === 0) {
      this.endpoints = this.endpointsData;
    }
  }

  resetEndpointsFilter(): void {
    this.selectedStatus = [];
    this.sidenavService.searchFilter.next('data');
    this.dropdownsList[0].options.filter((item) => {item.selected = false});
    this.status = undefined;
    this.endpoints = this.endpointsData;
    localStorage.removeItem('filteredEndpointsStatus');
  }

}
